import { render, staticRenderFns } from "./admin-user-management.vue?vue&type=template&id=124f04ac&scoped=true"
import script from "./admin-user-management.vue?vue&type=script&lang=ts"
export * from "./admin-user-management.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f04ac",
  null
  
)

export default component.exports